import { ABBR_TO_STATE } from "./location-format.data";
import { StringFormat } from "./string-format";

export type LatLngRange = {
  latitude: string;
  longitude: string;
  range: string;
};

export abstract class LocationFormat {
  /**
   * Check if an string is a valid state abbr
   *
   * @param abbr
   * @returns
   */
  static isValidAbbr(abbr: string): boolean {
    const key = abbr.toUpperCase();

    return !!ABBR_TO_STATE?.[key];
  }

  /**
   * Check if a given string is a valid state name
   *
   * @param state
   * @returns
   */
  static isValidState(state: string): boolean {
    const states = Object.values(ABBR_TO_STATE);

    return !!states.find(
      (item) => StringFormat.formatSlug(state) === StringFormat.formatSlug(item)
    );
  }

  /**
   * Gets an state name from a given abbr
   *
   * @param abbr
   * @returns
   */
  static stateFromAbbr(abbr: string): string | null {
    if (!LocationFormat.isValidAbbr(abbr)) {
      return null;
    }

    const key = abbr.toUpperCase();

    return ABBR_TO_STATE?.[key];
  }

  /**
   * Gets an abbr from a given state name
   *
   * @param state
   * @returns
   */
  static abbrFromState(state: string): string | null {
    if (!LocationFormat.isValidState(state)) {
      return null;
    }

    for (const abbr in ABBR_TO_STATE) {
      const stateName = ABBR_TO_STATE[abbr];

      if (
        StringFormat.formatSlug(stateName) === StringFormat.formatSlug(state)
      ) {
        return abbr.toUpperCase();
      }
    }

    return null;
  }

  /**
   * Format lat lng range to a single string
   *
   * @param latitude
   * @param longitude
   * @param range
   * @returns
   */
  static formatLatLngRange(latitude: string, longitude: string, range: string) {
    return `${latitude},${longitude}x${range}km`;
  }

  /**
   * Transform coordinates from string to object
   *
   * @param input
   * @returns
   */
  static transformLatLngFromString(input: string): LatLngRange | null {
    const regex = /^(-?\d{1,2}\.\d+),(-?\d{1,3}\.\d+)x(\d+)km$/;
    const match = RegExp(regex).exec(input);

    if (!match) {
      return null; // Return null if string is invalid
    }

    const latitude = match[1];
    const longitude = match[2];
    const range = match[3];

    return { latitude, longitude, range };
  }
}
